import { useTranslation } from 'i18n';
import { Box, StatCard } from 'ui';
import { Check, WarningAmber } from 'ui/icons';

export const EvidenceSessionStats = ({ failed, passed }: { failed: number; passed: number }) => {
  const { t } = useTranslation('features');

  return (
    <Box
      data-testid="evidence-session-stats"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
      }}
    >
      <StatCard
        icon={<Check color="success" />}
        title={t('evidence.sessionStats.includedTitle')}
        value={passed}
        subtitle={t('evidence.sessionStats.includedSubtitle')}
      />
      <StatCard
        icon={<WarningAmber color="warning" />}
        title={t('evidence.sessionStats.excludedTitle')}
        value={failed}
        subtitle={t('evidence.sessionStats.excludedSubtitle')}
      />
    </Box>
  );
};
